module.exports = __webpack_public_path__ + "img/brushes_en.7ea88bd.jpg";